import PropTypes from "prop-types"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Card, Row, CardBody, Col, Table, CardImg, Badge } from "reactstrap"
import ReactCardFlip from "react-card-flip"
import { formatNumber } from "../../util/common"
import CopyToClipboard from "react-copy-to-clipboard"
import { Tooltip } from "antd"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import toastr from "toastr"
import moment from "moment-timezone"
import { NO_PERMISSION_MESSAGE } from "constants/uiConstants"

const ContestCard = props => {
  const [isFlipped, setIsFlipped] = useState(false)
  const [contest, setContest] = useState(props.contest)
  const dispatch = useDispatch()
  const customClassname = props.customClassname || ""

  const realStatPermissionContest =
    // props.currentUser.jotUserType < 3 ||
    props.currentUser.permissions &&
    props.currentUser.permissions.includes("VIEW_REAL_STATS")

  const _onEdit = () => {
    if (!props.currentUser?.permissions?.includes("VIEW_MANAGE_CONTEST")) {
      toastr.error(NO_PERMISSION_MESSAGE)
      return
    }
    props.history.push(`/contest/manage?contestUuid=${contest.contest_id}`)
  }

  const _getRealStats = () => {
    return (
      <>
        <tr className="text-start">
          <th scope="row">Real Views:</th>
          <td>{formatNumber(contest.view_count) || 0}</td>
        </tr>
        <tr className="text-start">
          <th scope="row">Real Likes:</th>
          <td>{formatNumber(contest.like_count) || 0}</td>
        </tr>
        <tr className="text-start">
          <th scope="row">Real Shares:</th>
          <td>{formatNumber(contest.share_count) || 0}</td>
        </tr>
        <tr className="text-start">
          <th scope="row">Real Downloads:</th>
          <td>{formatNumber(contest.download_count) || 0}</td>
        </tr>
      </>
    )
  }

  return (
    <ReactCardFlip isFlipped={isFlipped} flipDirection={"horizontal"}>
      <Card
        className={`${customClassname} text-center shadow-lg`}
        style={{ borderRadius: "10px" }}
      >
        <CardBody className="px-0 py-0">
          <div
            role="button"
            onClick={() => {
              props.pageSource && props.pageSource === "searchAndSelect"
                ? ""
                : _onEdit()
            }}
          >
            <CardImg
              top
              src={
                contest.backgroundUrl &&
                !contest.backgroundUrl.includes("undefined")
                  ? contest.backgroundUrl
                  : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAACqCAMAAAAKqCSwAAAAP1BMVEX///+rq6uqqqr5+fn8/Py3t7f09PSurq68vLzg4ODa2tqysrLf39/AwMDy8vLQ0NDKysro6Ojr6+vU1NTMzMyk0bFSAAAIB0lEQVR4nO1bi5KrKBCNgKLgA9T//9alHygYk0nm7l6tWk5NTQwKOYEGuk+Tx6OgoKCgoKCgoKCgoKCgoKCgoKCgoKDgU0i/TBmMV1dzOsforMhR2am5mtUZmkFUz3Dyal4nMCdEq0p3V/N6hmzPOrUS7n7m2unTXq3sfDWzCDn7DnFqqWitdN+P13av8oOteLa/BN3XtfNXMl3sO45Hxra/jmqvPyaKZO1l/drUXzENXIerVtkXk/6N7V62HJgzPkLbOsCe2sZlG8JywqZeu7mRspl7Z+9MVeh1Xz3V7J569jZURd1ly7w0VtyTqqhpLZJjAE511R+43oUqrZqNGazWdjBItte3pLrA6M9DJchsHXjVyon7URX1CEwTV3DAAns/qtUUSmTmX63q2K33oIosfGaauDdlwcE9qCKvKbde8KSy3fcmVGEWrTlVE4p8ul7dhOr4iurtelXDqppHrUisv58BYBfO6WiLFmxiut8KgFG0WpICDeTz5esmVHFflWv0poTG3SvfWe9BlaMRudQYBlS1AaZje8ONNfDAbnyMxjm39rAgPKSrqjtSDVwpylMBeNGs+qZUqxAEpPfnQ5/eiWoIrUyMWNQcrPbOVMN0ckvnfb+AQnQfqueKqqh0wAnPire0K+CPUd5PEHb8udX/BPKlUPkK62XC5fydaCWGC5MYfqjEx9DuquFHNMa1H8L1VydbVPMZ5P3SFwUFBQUFBX8LsjPGUBJC9uGSXWI1Q/lTEroxUKoeCu4aOrHS9Hg9J+2ZNKvReCyZOXKkmoyvEnFNDa4QyCMg7gjhiDTlqW3t8sY8OE6DBAcWUIOv15PPZfgJPNay51jHqcamtB2Qv2xTH2z6kipo5sAInFKxQpkLjcMfJKFN2rG+IsWCfW0ISxSLgkRVkXIlJq7loSe4KQ1N0RmN31MlXzhSlSiVa1uDCil0mjA/UK2W0ECbUuXEMfV3jHR0TU2BiExUMeUZsHxPFbMmkSqqT9Y0cnZ6/9RnqmFgh1BLh2+1UYW6NvCjL0j5gcHLxg9Ca7swVesl4St/MVK1XaSqgAZZLzJK4+SUqh4w2RKiWQuPUQXgNoV/dOgGpE1KyDzmqfeQjiOqv8prR6qiHZkqlMSIE6JqNN8zqpMV4Wu4MM9cpAoZIe0hK7BlMjazJSBV3Q6I9atwAalaGEHniSp8nGipka7KTyVlVE1YBqYxzJtlilTDRaja1GTGpA7DjcUhFplPq/qraBH7cFhCP2hnv6PaTeG610L7SBUbm5hxs1NVvEKFsj+l6pqojwWqIxoYUe2R6v50TjUMtEWDjVRh5PXadWtFJg4CkliYKgnxZADD1stfU1VRyQ1UeY7i3TWO4ClVHGiozVQ5IUhnRGAwgDoKx9Mw1AnV32kvRFU+OtJ6YA7hsEHeVHVgw+l0zakyNfNgqnmaNdTDiYBirJLLv0aV8xBAdcRFoZ0WPOkhUk0np/rAOnqOVJdqM0PeH1CX08O0rINODcAtBPOa2GuqfNQTVybsYfrAsBKlPXCgCpsRzECiivuWdWuA45GXruKm4EVPhxVAtN/sAeiuYB5ihiuaQ37Q3JZds0mauiuBKlZeVbBVcFfQb6E5iE4JTKyY3ICmnFdHd+U7qqDv0Crdg4pDu7L0ywCSjpnztmZ4JCzccg2vYeYt4SUQMuGlV/Cm5a0NSloc3tGsWImbkpme9N1BUrXlHtLLw5unp59fVFZDHd/kLWz4hmlBQUFBwf8UYw8n+SlOC5c9+3tN13c97NjKQ2nHHrAMz2IxPNvlHjw9GX8g1HQbPD2HVXbPB98y+k+CwuBwAjDOM1X0W+DAMsgJCv1B8DtYKxk1BRlYrcoP1LOqwp/a71ku3aLoAR6NWA4fzPjEE6BzPRTijBio4keBiyeSw3PRZR1ZFiCXOqMaVZUlUk1Sg6gJ4P2UavLAJ1TBF44hiZo2jQQDQagfRRQK5d9RjapK2+xUtbVWVzFkOaFqGR8kZJFJHc/NwOkzkEu4L3suAq2Ew6s3VElV2fQNDB+HpmkMVjmnqvuYlPu5U+G4ZG0sh0/bsIO8gkYBoyoc/CMbfk1V5arKHun6OEBnVD8/M6CwaQxUUJEzbAFowVAyQkTaYdf691RJVQldy9aOVG0In6GFejuaeTCAlkLs9eegEIQfbR5LNDGcWKH/TJXoOPUI0RCpOa+pUhubqkK2yiEVnSE/oxojmZ8XK0OnITAk7mNzdsbxhxFHiwiDt8RDyy+pNi2pKqtgXSalqiGy+TOqNKk639dxOuGxTjPaZFJVzntUicw7qqiqTN5HVWU3AIypwQL+yACyM8j7xBqWap9U+9oH3fyK6vMqSSsANAmNsIz162l1OB2PEysuOTyp0gdgYuVUDS816qiqjKnWBb/U2SSbKVb5jioyEVELoYm16cJ4mlZv5lRRz+RUNa3fYXQPqophqrUxZrJV0quxCktILiZaftgCcGkia6mjifHZr21SsWQ3MMWcKo+39ayqbE+G2rSxxm9p5+wgrohqV/QB7Ps9AFUOnnvkqbAiDs3j0WkdCyn1E2wzc1e2z/FdtbkcTUveTeKucJJmSgqQavrAe6pzW9c1//h4hGvUpqSDvAcePTJwxfIXXk+qaemmmuodrV/ghVWVhfImfr/tlnlrYquStVD/8Os8lSY49mwHFsvjA7E03lQygXp6UqUPZE1sZdnbqw8QFRQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQU/DX8AwPBZjzDX2+vAAAAAElFTkSuQmCC"
              }
              width="100%"
              height="200px"
            />
            <div style={{ height: "20px" }} className="my-3 mx-2">
              <h5 className="font-size-20 text-truncate text-dark">
                {contest.hashtag}
              </h5>
            </div>
          </div>

          <div className="my-1 mb-1">
            <Badge pill className="badge-soft-success m-1">
              <Tooltip title="Contest Start Date">
                <div className="p-1 font-size-14">
                  {" "}
                  {moment(contest.start_date).format("Do MMMM YYYY")}
                </div>
              </Tooltip>
            </Badge>
          </div>
          <div className="my-1 mb-2">
            <Badge pill className="badge-soft-danger m-1">
              <Tooltip title="Contest End Date">
                <div className="p-1 font-size-14">
                  {" "}
                  {moment(contest.end_date).format("Do MMMM YYYY")}
                </div>
              </Tooltip>
            </Badge>
          </div>

          <div className="d-flex justify-content-around align-items-center border-top py-3">
            <div className="d-flex flex-column">
              <i
                className="bx bx-show"
                style={{ padding: "2px", fontSize: "16px" }}
              />
              <span>
                {formatNumber(contest.view_count + contest.fk_views) || 0}
              </span>
            </div>
            <div className="d-flex flex-column">
              <i
                className="bx bx-like"
                style={{ padding: "2px", fontSize: "16px" }}
              />
              <span>
                {formatNumber(contest.like_count + contest.fk_likes) || 0}
              </span>
            </div>
            <div className="d-flex flex-column">
              <i
                className="bx bx-share-alt"
                style={{ padding: "2px", fontSize: "16px" }}
              />
              <span>
                {formatNumber(contest.share_count + contest.fk_shares) || 0}
              </span>
            </div>
            <div>
              <Tooltip title="View More">
                <i
                  className="bx bx-play"
                  role="button"
                  style={{ fontSize: "20px" }}
                  onClick={e => {
                    e.preventDefault()
                    e.stopPropagation()
                    setIsFlipped(true)
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </CardBody>
        <div className="contact-links d-flex font-size-20 p-2 bg-light border-top">
          <div className="flex-fill">
            <CopyToClipboard
              text={contest.contest_id}
              onCopy={e => {
                toastr.success("Copied sucessfully!")
              }}
            >
              <Tooltip title="Copy contest ID">
                <i role="button" className="bx bx-copy" />
              </Tooltip>
            </CopyToClipboard>
          </div>
          <div className="flex-fill">
            <Tooltip title="Edit">
              <i role="button" className="bx bx-edit-alt" onClick={_onEdit} />
            </Tooltip>
          </div>
          <div className="flex-fill">
            <Tooltip title="Edit In New Window">
              <Link
                to={`/contest/manage?contestUuid=${contest.contest_id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bx-link-external"></i>
              </Link>
            </Tooltip>
          </div>
        </div>
      </Card>
      <Card
        className="text-center shadow-lg"
        style={{ height: "450px", borderRadius: "10px" }}
      >
        <CardBody className="px-0 py-0">
          <Row className="my-sm-2">
            <Col>
              <div className="avatar-xs">
                <div className="avatar-title rounded-circle bg-light">
                  <span
                    title={
                      contest.display_persona || "display persona not known"
                    }
                    className={
                      "avatar-title rounded-circle bg-light bg-" +
                      "secondary" +
                      " text-warning" +
                      " font-size-16" +
                      " font-weight-semibold"
                    }
                  >
                    <i className="bx bx-bar-chart" />
                  </span>
                </div>
              </div>
            </Col>
            <Col className="d-flex justify-content-end me-1">
              <div
                className="avatar-xs"
                role="button"
                onClick={() => setIsFlipped(false)}
              >
                <div className="avatar-title rounded-circle bg-light">
                  <span
                    className={
                      "avatar-title rounded-circle bg-light bg-" +
                      "secondary" +
                      " text-dark" +
                      " font-size-16" +
                      " font-weight-semibold"
                    }
                  >
                    <i className="fas fa-times-circle" />
                  </span>
                </div>
              </div>
              <div></div>
            </Col>
          </Row>
          <Row>
            <div className="table-responsive" role="button" onClick={_onEdit}>
              <Table className=" mb-0 table-striped">
                <tbody>
                  <tr className="text-start">
                    <th scope="row">Views:</th>
                    <td>
                      {formatNumber(contest.fk_views + contest.view_count) || 0}
                    </td>
                  </tr>
                  <tr className="text-start">
                    <th scope="row">Likes:</th>
                    <td>
                      {formatNumber(contest.fk_likes + contest.like_count) || 0}
                    </td>
                  </tr>
                  <tr className="text-start">
                    <th scope="row">Shares:</th>
                    <td>
                      {formatNumber(contest.fk_shares + contest.share_count) ||
                        0}
                    </td>
                  </tr>
                  <tr className="text-start">
                    <th scope="row">Downloads:</th>
                    <td>
                      {formatNumber(
                        contest.fk_downloads + contest.download_count
                      ) || 0}
                    </td>
                  </tr>
                  {realStatPermissionContest && _getRealStats()}
                </tbody>
              </Table>
            </div>
          </Row>
        </CardBody>
      </Card>
    </ReactCardFlip>
  )
}

ContestCard.propTypes = {
  contest: PropTypes.object,
}

export default withRouter(ContestCard)
